<template>
<div>
    <s-text :readonly=readonly :disabled=disabled label="OC/OS" @click="dialog=true" v-model="textDescription" :outlined="outlined" />
    <v-dialog width="80%" v-model="dialog" v-if=dialog transition="dialog-bottom-transition">
        <c-order-purcharse style="overflow: hidden !important; " @dblClick="dblClick($event)" @close="dialog=false" :AreID="AreID"></c-order-purcharse>
    </v-dialog>

</div>
</template>

<script>
import cOrderPurcharse from '@/components/Logistics/cOrderPurcharse.vue'
export default {
    components: {
        cOrderPurcharse
    },
    props: {
        value: null,
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        outlined:{
            type: Boolean,
            default: true
        },
        AreID: null


    },
    data() {
        return {
            order: null,
            textDescription: '',
            dialog: false,
        };
    },
    methods: {
        dblClick(item) {
            this.order = item;
            this.$emit('input', item);
            this.textDescription = item.OrdDocumentNumber;
            this.dialog = false;
        }
    },
    created() {

        console.log("eeeeeeeeeeeeeeeeeeeeee",this.value)
        this.order = this.value;
        if (this.order != null) {
            this.textDescription = this.order.OrdDocumentNumber;
        }
    },
    
    watch: {
        value() {
            this.textDescription = this.value.OrdDocumentNumber;

        }
    },
};
</script>
